export const energyDataBadges = {
  energyDataDocuments: {
    id: "hasAnyEnergyDataDocument",
    type: "documents",
    label: "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DOCUMENTS_LABEL",
    key: "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DOCUMENTS_HEADER",
    class: "documents"
  },
  energyMonitorNewData: {
    id: "energyMonitorNewData",
    type: "primary",
    label: "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DATA_LABEL",
    key: "NOTIFICATION_SERVICE.EDIT.ENERGY_DATA.DATA_HEADER",
    class: "primary"
  }
};
